import FormPlan from '../componentes/FormPlan.vue'
import ListaPlan from '../componentes/ListaPlan.vue'
import CalendarioPlan from '../componentes/CalendarioPlan.vue'
import MapaPlan from '../componentes/MapaPlan.vue'


const routes = [
    ...route('/guardar-plan-orden', FormPlan, {
        Auth: true,
        ///req_admin: true
     }),
     ...route('/lista-plan-orden', ListaPlan, {
       Auth: true,
       //req_admin: true
    }), ...route('/calendario-plan-orden', CalendarioPlan, {
        Auth: true,
        //req_admin: true
     }),

     ...route('/mapa-plan-orden', MapaPlan, {
        Auth: true,
        //req_admin: true
     }),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes